// @flow
import styled, { keyframes } from 'styled-components';
import { VelocityTransitionGroup } from 'velocity-react';

import { DURATION, EASING } from '../constants';

const revealOpacity = keyframes`to { opacity: 1; }`;

export const TransitionGroup = styled(VelocityTransitionGroup)`
    left: 0;
    position: absolute;
    top: 0;
`;

export const Position = styled.div`
    left: 0;
    position: absolute;
    top: 0;
`;

export const Container = styled.div`
    animation: ${revealOpacity} ${DURATION} ${EASING} forwards;
    animation-delay: ${DURATION};
    height: ${p => p.size}px;
    left: 0;
    opacity: 0;
    position: absolute;
    top: 0;
    width: ${p => p.size}px;
`;

export const HueWarningMessage = styled.div`
    line-height: 1.5em;
    text-align: center;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/picker-container/style.js